module.exports = __webpack_public_path__ + "media/คืนไม่ได้ค่ะ.6e8f2c45.mp3";